import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ToursSection from './components/ToursSection';
import GallerySection from './components/GallerySection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';

export default function HomePage() {
  return (
    <main className="relative w-full">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ToursSection />
      <GallerySection />
      <FAQSection />
      <ContactSection />

      {/* WhatsApp floating button */}
      <a
        href="https://wa.me/61455957263?text=Hi!%20I'd%20like%20to%20book%20a%20dive%20trip%20to%20Bedarra%20Island."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp to book"
        className="whitespace-nowrap fixed bottom-7 right-7 z-50 flex items-center gap-2.5 bg-green-500 hover:bg-green-600 active:bg-green-700 text-white pl-3.5 pr-5 py-3.5 rounded-full cursor-pointer transition-all duration-300 hover:scale-105 group"
      >
        <span className="absolute inset-0 rounded-full bg-green-400 opacity-40 animate-ping pointer-events-none"></span>
        <div className="w-6 h-6 flex items-center justify-center shrink-0 relative">
          <i className="ri-whatsapp-line text-2xl"></i>
        </div>
        <span className="text-sm font-bold relative">Book via WhatsApp</span>
      </a>
    </main>
  );
}
